import { gql } from "graphql-tag";

export const SYNC_WMS_DATA = gql`
	mutation SyncWmsData {
		sync_wms_data
	}
`;

// send a failed stock deduction to Smart again; returns the new attempt (JSON string)
export const RESEND_WMS_WEBHOOK = gql`
	mutation ResendWmsWebhook($id: Int!) {
		resend_wms_webhook(id: $id)
	}
`;
